export enum TripDetailsViewType {
  table = 'table',
  map = 'map',
}
